import React, { useState, useEffect, useRef } from "react";
import TalkingAvatar from "../avatar/TalkingAvatar";
import Whiteboard from "../whiteboard/Whiteboard";
import SearchBar from "../search/SearchBar";
import * as styles from "../../App.css";
import {SquareLoader} from 'react-spinners';
//import { GLTFLoader } from 'three/examples/js/loaders/GLTFLoader';
import {GLTFLoader} from 'three-stdlib'
import { useLoader } from '@react-three/fiber';
import { OrbitControls } from '@react-three/drei';
import { Canvas } from '@react-three/fiber';
import { TalkingHead } from "../../modules/talkinghead";
import * as en from "../../modules/lipsync-en.mjs"
import { element } from "three/webgpu";
import RaiseHandButton from "../hand/raise-hand";
import DoubtBar from "../search/DoubtBar";
import { section, text } from "framer-motion/client";
import ImageViewer from "../image-viewer/image-viewer";
import VideoPlayer from "../video-viewer/video-player";
import QuizApp from "../quizapp/quiz-app";
import InteractiveQuestion from "../interactivequestion/interactive-question";
import Mp4Player from "../video-viewer/mp4-player";
import Rocket from "../rocket/rocket";
import { Pause, Play, RotateCcw, Check, X, ArrowRight, LogOut } from "lucide-react";
import HistorySidebar from "../menubar/menu-bar";
import Recommendations from "../recommendations/recommendations";
import "./../login/login-page.css";
//plato-vm.westus.cloudapp.azure.com

const OutOfCreditsModal = ({ userId, email, onCreditUsed }) => {
  const [requestEmail, setRequestEmail] = React.useState(email || "");
  const [submitted, setSubmitted] = React.useState(false);

  const handleRequest = async () => {
    if (!requestEmail.trim()) return;
    try {
      const token = localStorage.getItem("google_token");
      await fetch('https://plato-vm.westus.cloudapp.azure.com:5001/Transcript/RequestMoreCredits', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({ userId, email: requestEmail.trim() })
      });
      setSubmitted(true);
    } catch (e) { console.error('Failed to request credits', e); }
  };

  return (
    <div style={{
      position: "fixed", inset: 0, zIndex: 9999,
      background: "rgba(5,15,30,0.92)", backdropFilter: "blur(10px)",
      display: "flex", alignItems: "center", justifyContent: "center",
    }}>
      <div style={{
        background: "rgba(255,255,255,0.07)", border: "1px solid rgba(255,255,255,0.14)",
        borderRadius: "20px", padding: "40px 44px", width: "360px",
        boxSizing: "border-box", textAlign: "center", boxShadow: "0 20px 60px rgba(0,0,0,0.5)",
      }}>
        <div style={{ fontSize: "36px", marginBottom: "12px" }}>🎓</div>
        <h2 style={{ color: "white", margin: "0 0 8px", fontSize: "20px", fontWeight: 700 }}>
          You've used all your credits
        </h2>
        <p style={{ color: "rgba(255,255,255,0.5)", fontSize: "13px", margin: "0 0 28px", lineHeight: 1.6 }}>
          You've generated 5 lessons. Leave your email and we'll top you up shortly.
        </p>
        {!submitted ? (
          <>
            <input
              type="email"
              value={requestEmail}
              onChange={e => setRequestEmail(e.target.value)}
              placeholder="Your email address"
              style={{
                width: "100%", padding: "10px 14px", borderRadius: "10px",
                border: "1px solid rgba(255,255,255,0.2)",
                background: "rgba(255,255,255,0.08)", color: "white",
                fontSize: "14px", outline: "none", boxSizing: "border-box",
              }}
            />
            <button
              onClick={handleRequest}
              style={{
                marginTop: "14px", width: "100%", padding: "12px",
                borderRadius: "10px", border: "none",
                background: "rgba(99,179,237,0.85)", color: "white",
                fontSize: "14px", fontWeight: 700, cursor: "pointer",
              }}
            >
              Request More Credits
            </button>
          </>
        ) : (
          <p style={{ color: "rgba(99,237,140,0.9)", fontSize: "14px", fontWeight: 600 }}>
            ✓ Request received! We'll be in touch soon.
          </p>
        )}
      </div>
    </div>
  );
};

const Home = ({profile, logOut, userId, creditsLeft, onCreditUsed, testMode, initialScreenplay, initialBackground, testModeTopic, onPartComplete}) => {

  const [currentLine, setCurrentLine] = useState(0);
  const [currentDoubtLine, setCurrentDoubtLine] = useState(0);
  const [highlightedSentence, setHighlightedSentence] = useState("");
  const [query, setQuery] = useState("");
  const [oldQuery, setOldQuery] = useState("");
  const [displayQuery, setDisplayQuery] = useState("");
  const [doubtQuery, setDoubtQuery] = useState("");
  const [screenplay, setScreenplay] = useState();
  const [doubtScreenplay, setDoubtscreenplay] = useState();
  const [screenplayLength, setScreenplayLength] = useState(0);
  const [error, setError] = useState(null); // State to store errors, if any
  const [loading, setLoading] = useState(false); // State to show a loading indicator
  const [doubtMode,setDoubtMode]=useState(false);
  const [resumed,setResumed]=useState(true);
  const [finishedTalking,setFinishedTalking]=useState(false);
  const [retriggerScreenplay,setRetriggerScreenplay]=useState(false);
  const [retriggerDoubtScreenplay,setRetriggerDoubtScreenplay]=useState(false);
  const [retriggerHistory,setRetriggerHistory]=useState(false);
  const [resumedDoubt,setResumedDoubt]=useState(false);
  //const [playAgain,setPaused]=useState(false)
  const [avatar, setAvatar] = useState(null);
  const [handRaised, setHandRaised] = useState(false);
  const [doubtControls, setDoubtControls] = useState(false);
  const [showConfirmationOptions, setShowConfirmationOptions] = useState(false);
  const [avatarPresent, setAvatarPresent] = useState(false);
  const [talkingHead, setTalkingHead] = useState();
  const [raiseHandStatus, setRaiseHandStatus] = useState(false);
  const [imageOrVideoOrQuizOnScreen, setImageOrVideoOrQuizOnScreen] = useState(false);
  const [backgroundUrl, setBackgroundUrl] = useState("");
  const [backgroundUrlActive, setBackgroundUrlActive] = useState("");
  const [timeSentence, setTimeSentence] = useState();
  const [correctAnswer, setCorrectAnswer] = useState(false);
  const [incorrectAnswer, setIncorrectAnswer] = useState(false);
  const [interactiveQuestionAnswered, setInteractiveQuestionAnswered] = useState(false);
  const [playVideo, setPlayVideo] = useState(false);
  const [rocket, showRocket] = useState(true);
  const [email, setEmail] = useState("");
  const [avatarLoadingProgress, setAvatarLoadingProgress] = useState(0);
  const [avatarLoading, setAvatarLoading] = useState(false);
  const [avatarReady, setAvatarReady] = useState(false);
  const [historyQueryId, setHistoryQueryId] = useState("");
  const [doubts, setDoubts] = useState([]);
  const [lessonCompleted, setLessonCompleted] = useState(false);
  let isPaused = false;
  const pausedRef = useRef(false); // Create a ref for `paused`
  const resumedRef = useRef(0); // Create a ref for `paused`
  const resumedRefDoubt = useRef(0); // Create a ref for `paused`
  const animWaitingSpokenRef = useRef(false);
  let defaultBackgroundUrl = "https://platovideo.z13.web.core.windows.net/brightResized.png";
  //let baseApiUrl = "https://plato-vm.westus.cloudapp.azure.com:5001/";
  let baseApiUrl = "https://plato-vm.westus.cloudapp.azure.com:5001/";
  
  let head = null;

  useEffect(() => {
    const initializeAvatar = async (initialJson) => {
      // Create the talking head avatar
      setAvatarLoading(true);
      setAvatarPresent(true);
      const nodeAvatar = document.getElementById('avatar');
      if (!nodeAvatar.hasChildNodes()) {
        // Create a new child div
        const childDiv = document.createElement('div');
      
        // Optionally, set properties or styles for the new div
        childDiv.id = "avatarInternal"
      
        // Append the child div to the parent
        nodeAvatar.appendChild(childDiv);
      }
      head = new TalkingHead( nodeAvatar, {
              ttsEndpoint: "https://texttospeech.googleapis.com/v1beta1/text:synthesize",
              ttsApikey: "", // <- Change this
              lipsyncModules: ["en"],
              cameraView: "upper"
      });
      setTalkingHead(head);
      setBackgroundUrlActive(defaultBackgroundUrl);

        // Load and show the avatar
      try {
        //nodeLoading.textContent = "Loading...";
        //debugger;
        await head.showAvatar( {
          //url: 'https://models.readyplayer.me/64bfa15f0e72c63d7c3934a6.glb?morphTargets=ARKit,Oculus+Visemes,mouthOpen,mouthSmile,eyesClosed,eyesLookUp,eyesLookDown&textureSizeLimit=1024&textureFormat=png',
          url: 'avaturn.glb',
          body: 'F',
          avatarMood: 'happy',
          ttsLang: "en-GB",
          ttsVoice: "en-GB-Standard-A",
          lipsyncLang: 'en'
        }, (ev) => {
          if ( ev.lengthComputable ) {
            let val = Math.min(100,Math.round(ev.loaded/ev.total * 100 ));
            setAvatarLoadingProgress(val);
            //nodeLoading.textContent = "Loading " + val + "%";
          }
        });
        setAvatarLoading(false);
        setAvatarReady(true);
        if (!testMode) {
          let totalTime = await head.speakText( "What do you want to learn about? Put it in the box above" );
        }
        //nodeLoading.style.display = 'none';

      } catch (error) {
        setAvatarPresent(true);
        console.log(error);
        //nodeLoading.textContent = error.toString();
      }
    }
    const nodeInternal = document.getElementById('avatarInternal');
    if(!avatarPresent && !nodeInternal)
      initializeAvatar();
  },[]);

  useEffect(() => {
    if(profile && profile.email){
      console.log(profile);
      var emailId = profile.email.split("@")[0];
      setEmail(emailId);
    }
  }, [profile]);

  useEffect(() => {
    // Speak when clicked
    const nodeSpeak = document.getElementById('speak');
    const waitForTwoSeconds = (time) => {
      return new Promise((resolve) => setTimeout(resolve, time));
    };

    let cancelled = false;

    const speakAvatar = async (initialJson) => {
    console.log(initialJson);
    while(true){
      let count = 0;
      for(var sentence of initialJson){
        if (cancelled) return;
        try {
          setDoubtControls(true);
          if(resumedRef.current == 2){  //resume
            if(count < currentLine){
              count++;
              continue;
            }
          }
          if(resumedRef.current == 1){
            talkingHead.pauseSpeaking();
            break;
          }
          if(resumedRef.current == 3){
            resumedRef.current = 0;
            setCurrentLine(0);
            break;
          }
          //const text = document.getElementById('text').value;
          const text = sentence.text;
          if ( text ) {
            let totalTime = await talkingHead.speakText( text );
            // Guard: if this loop was cancelled while awaiting speakText (e.g. due to a
            // retrigger or screenplay update), bail out before advancing currentLine.
            // Without this, the stale loop still calls setCurrentLine after its speech
            // resolves, double-incrementing the line counter and visually skipping a slide.
            if (cancelled) return;
            setTimeSentence(totalTime);
            console.log("time: " + totalTime);
            if((sentence.module == "start" || sentence.module == "image" || sentence.module == "genimage" || sentence.module == "video" || sentence.module == "manim" || sentence.module == "quiz" || sentence.module == "recommendation" || sentence.module == "interactivequestion") && (resumedRef.current == 2 || resumedRef.current == 0)){
               setImageOrVideoOrQuizOnScreen(true);
               if(sentence.module == "interactivequestion"){
                setInteractiveQuestionAnswered(false);
               }
               if(sentence.module == "video"){
                setPlayVideo(true);
               }
               // Auto-close images once speaking is done
               if(sentence.module == "image" || sentence.module == "genimage"){
                 setFinishedTalking(true);
               }
               // Pause for interactive modules and media — advance is triggered by modal close
               if(sentence.module == "quiz" || sentence.module == "interactivequestion" ||
                  sentence.module == "manim" || sentence.module == "video" ||
                  sentence.module == "image" || sentence.module == "genimage"){
                 resumedRef.current = 1;
                 continue;
               }
            }
            // else{
            //   setImageOrVideoOnScreen(false);
            // }
            //await waitForTwoSeconds(totalTime);
            if(resumedRef.current != 1 && count != screenplay.length-1){
              setCurrentLine((currentLine) => currentLine + 1);
            }
          }
          count++;
        } catch (error) {
          console.log(error);
        }
      }
      if(count != screenplay.length && resumedRef.current==0){
        continue;
      }
      if(count == screenplay.length){
        setBackgroundUrlActive(defaultBackgroundUrl);
        setLessonCompleted(true);
      }
      break;
    }

  }
  if(screenplay){
    speakAvatar(screenplay);
  }

    return () => { cancelled = true; };
  }, [screenplay, resumed, retriggerScreenplay]);

  // When paused on a manim slide whose video isn't ready yet, have the avatar
  // say the waiting message exactly once, then reset when the slide changes.
  useEffect(() => {
    if (!screenplay || currentLine < 0 || !talkingHead || !imageOrVideoOrQuizOnScreen) return;
    const line = screenplay[currentLine];
    if (line?.module === "manim" && (!line?.url || !line.url.toLowerCase().includes('.mp4'))) {
      if (!animWaitingSpokenRef.current) {
        animWaitingSpokenRef.current = true;
        talkingHead.speakText(
          "Animation still generating. Take a sip of water meanwhile and take a deep breath."
        );
      }
    } else {
      animWaitingSpokenRef.current = false;
    }
  }, [currentLine, screenplay, talkingHead, imageOrVideoOrQuizOnScreen]);

  // Load the avatar 3D model using GLTFLoader

  useEffect(() => {   
    const speakAvatar = async (initialJson) => {
    let count = 0;
    for(var sentence of initialJson){
      try {
        setDoubtControls(false);
        //const text = document.getElementById('text').value;
        if(resumedRefDoubt.current == 2){  //resume
          if(count < currentDoubtLine){
            count++;
            continue;
          }       
        }
        if(resumedRefDoubt.current == 1){
          talkingHead.pauseSpeaking();
          break;
        }
        if(resumedRefDoubt.current == 3){
          resumedRefDoubt.current = 0;
          setCurrentDoubtLine(0);
        }
        const text = sentence.text;
        if ( text ) {
          let totalTime = await talkingHead.speakText( text );
          setTimeSentence(totalTime);
          console.log("time: " + totalTime);
          if((sentence.module == "image" || sentence.module == "video" || sentence.module == "quiz") && (resumedRefDoubt.current == 2 || resumedRefDoubt.current == 0)){
             setImageOrVideoOrQuizOnScreen(true);
             resumedRefDoubt.current = 1;
             continue;
          }
          // else{
          //   setImageOrVideoOnScreen(false);
          // }
          //await waitForTwoSeconds(totalTime);
          if(resumedRefDoubt.current != 1 && count != doubtScreenplay.length-1){
            setCurrentDoubtLine((currentDoubtLine) => currentDoubtLine + 1);
          }
        }
        count++;
      } catch (error) {
        console.log(error);
      }
    }
    setCurrentDoubtLine(0);
    setDoubtscreenplay(null);
    triggerHandBroughtDown(); 
    setDoubtMode(false);
  }
  if(doubtScreenplay){
    speakAvatar(doubtScreenplay);
  }
  }, [doubtScreenplay, resumedDoubt, retriggerDoubtScreenplay]);

  
  useEffect(() => {   
    console.log(currentLine);    
  }, [currentLine]);

  useEffect(() => {  
      const speakAvatarHandRaisedOrBroughtDown = async () => { 
      if(talkingHead){
        if(handRaised){
          let totalTime = await talkingHead.speakText( "Go on, shoot your question" );
        }
        else{
          let totalTime = await talkingHead.speakText( "Hope my clarification helped, may I continue with the lesson?" );
          setRaiseHandStatus((raiseHandStatus) => !raiseHandStatus);
          setShowConfirmationOptions(true);
        }
      }
  }   
  speakAvatarHandRaisedOrBroughtDown();
  }, [handRaised]);

  useEffect(() => {
    console.log(currentLine);
    if(screenplay && resumed){
      talkingHead.startSpeaking(true);
      resumedRef.current = 2;
    }
  }, [resumed]);

  useEffect(() => {   
    if(doubtScreenplay && resumedDoubt){
      talkingHead.startSpeaking(true);
      resumedRefDoubt.current = 2;
    }
  }, [resumedDoubt]);

  useEffect(() => {
    if (!lessonCompleted || !screenplay) return;
    setLessonCompleted(false);
    if (testMode) {
      if (onPartComplete) onPartComplete();
      return;
    }
    const token = localStorage.getItem("google_token");
    fetch(`${baseApiUrl}Transcript/SaveLessonMemory`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
      body: JSON.stringify({
        userId,
        topic: displayQuery,
        transcriptJson: JSON.stringify(screenplay),
        doubts
      })
    }).catch(e => console.error('Failed to save lesson memory', e));
  }, [lessonCompleted]);

  useEffect(() => {
    var container = document.getElementsByClassName("container")[0];
    container.style.backgroundImage = "url('" + backgroundUrlActive + "')";
    console.log(container.style.backgroundImage)
    container.style.backgroundSize = "100% 100%";
    if(backgroundUrlActive == defaultBackgroundUrl){
      container.style.animation = "none";
      showRocket(true);
    }
    else{
      container.style.animation = "moveBackground 10s linear infinite";
      showRocket(false);
    }
  }, [backgroundUrlActive]);

  const handleUserResponse = async (response) => {
    if (response.toLowerCase() === "yes") {
      setDoubtMode(false);
      //resetTranscript();
      updateCurrentLine(); // Resume normal screenplay
    } else if (response.toLowerCase() === "no") {
      //const newAnswer = await handleChatGPTCall(doubtQuery);
      //setDoubtScreenplay([{ text: newAnswer, module: "avatar" }]);
    }
  };

  function getId(url) {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);

    return (match && match[2].length === 11)
      ? match[2]
      : null;
  }

  useEffect(() => {
    if(oldQuery){
      setDisplayQuery(oldQuery);
    }
  },[oldQuery]);

  const setHistoryQuery = (id, title, backgroundUrl) => {
    console.log(id + " " + title + " " + backgroundUrl);
    setOldQuery(title);
    if(backgroundUrl)
      setBackgroundUrlActive(backgroundUrl);
    setHistoryQueryId(id);
  }

  const triggerNewTopic = (newTopic) => {
    setQuery(newTopic);
  }

  useEffect(() => {
    const loadNewQueryTranscript = async (historyQueryId) => {
      setLoading(true);
      const token = localStorage.getItem("google_token");
      try{
        const newTranscript = await fetch('https://plato-vm.westus.cloudapp.azure.com:5001/Transcript/GetTranscriptFromHistory?transcriptId='+historyQueryId,{
          method: "GET",
          headers: {
              "Authorization": `Bearer ${token}`
          }});
        const newTranscriptJson = await newTranscript.json();
        setScreenplay(newTranscriptJson);
        setCurrentLine(0);
        resumedRef.current = 0;
        setRetriggerScreenplay((retriggerScreenplay) => !retriggerScreenplay);
        // resumedRef.current = 0;
        // setCurrentLine(0);
        // setBackgroundUrlActive(defaultBackgroundUrl);
        // setImageOrVideoOrQuizOnScreen(false);
      }
      catch(err){
        console.error("Error processing images:", err);
      }finally{
        setLoading(false);
      }
    }
    if(historyQueryId){
      loadNewQueryTranscript(historyQueryId);
    }
  },[historyQueryId]);

  // Load a pre-generated screenplay in test mode. Waits for the avatar to be
  // ready before starting playback, and re-runs whenever the active part changes.
  useEffect(() => {
    if (!testMode || !initialScreenplay || !avatarReady) return;
    if (talkingHead) talkingHead.stopSpeaking();
    setPlayVideo(false);
    setImageOrVideoOrQuizOnScreen(false);
    setCurrentLine(0);
    resumedRef.current = 0;
    setScreenplay(initialScreenplay);
    setRetriggerScreenplay(r => !r);
    if (initialBackground) setBackgroundUrlActive(initialBackground);
  }, [initialScreenplay, avatarReady]); // eslint-disable-line react-hooks/exhaustive-deps

  const completedWeight = useRef(0);
  const [progress, setProgress] = useState(0);
  useEffect(() => {

    const weights = {
      image: 2,
      video: 4,
      manim: 5,
      recommendation: 2
    };

    

    const processImages = async (initialJson, token) => {
      try {
        var imgUrlsList = [];
        var videoUrlsList = [];
        const totalWeight = initialJson.reduce((sum, item) => sum + (weights[item.module] || 0), 0);
        completedWeight.current = 0;
        setProgress(0);
        const updateProgress = (item) => {
          completedWeight.current += weights[item.module] || 0;
          const percentage = Math.round((completedWeight.current / totalWeight) * 100);
          setProgress(percentage);
          console.log(percentage);
        };
        // Calculate total weight
        // Clone the data to modify
        const updatedDataWithoutManim = await Promise.all(
          initialJson.map(async (item) => {
            let updatedItem = { ...item };
            console.log("image urls");
            console.log(imgUrlsList);
            // If module is "image", call the API
            if (item.module === "image") {
              const index = initialJson.indexOf(item);
              const subArrayString = JSON.stringify(initialJson.slice(0, index + 1));
              var imgUrlsListStringified = JSON.stringify(imgUrlsList);
              const imageUrls = await fetch(`https://plato-vm.westus.cloudapp.azure.com:5001/Transcript/GetImage?imageQuery=${encodeURIComponent(item.url)}&topic=${encodeURIComponent(query)}&currentCaption=${encodeURIComponent(item.text)}`, {
                method: "POST",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ transcriptCovered: subArrayString, urlsCovered: imgUrlsListStringified })
              }); // Simulate API call for images
              var imageUrlsText = await imageUrls.text();
              var imageUrlsParsed = JSON.parse(imageUrlsText);
              imgUrlsList.push(imageUrlsParsed["url"]);
              // debugger;
              // var imageUrlsString =  imageUrlsParsed.join(",");
              // const imgCaption = await fetch('https://plato-vm.westus.cloudapp.azure.com:7169/Transcript/GenerateImageDescription?imgUrlsString='+imageUrlsString+"&prompt="+item.text+"&topic="+query); 
              // var imgCaptionJson = await imgCaption.json();
              updatedItem = { ...item, url: imageUrlsParsed["url"], text: imageUrlsParsed["newCaption"] }; // Replace `url` with array of URLs
              updateProgress(item);
            }
            if (item.module === "video") {
              var videoUrlsListStringified = JSON.stringify(videoUrlsList);
              const videoResponseTask = await fetch(`https://plato-vm.westus.cloudapp.azure.com:5001/Transcript/GetShortVideos?videoQuery=${encodeURIComponent(item.url)}&lessonText=${encodeURIComponent(item.text)}&currentCaption=${encodeURIComponent(item.text)}`, {
                method: "POST",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ urlsCovered: videoUrlsListStringified })
              }); // Simulate API call for video
              const videoResponse = await videoResponseTask.json();
              var caption = videoResponse["newCaption"]??"";
              const videoId = videoResponse["videoId"]??"";
              const sourceEmbedUrl = 'https://www.youtube.com/embed/' + videoId;
              if(videoId)
                videoUrlsList.push(videoId);
              updatedItem = { ...item, url: sourceEmbedUrl, text: caption }; // Replace `url` with video url
              updateProgress(item);
            }
            if (item.module === "genimage") {
              const genImageResponseTask = await fetch('https://plato-vm.westus.cloudapp.azure.com:5001/Transcript/GenerateSlideImage?prompt=' + encodeURIComponent(item.url), {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                }});
              const genImageResponse = await genImageResponseTask.json();
              const genImageUrl = genImageResponse["url"] ?? "";
              updatedItem = { ...item, url: genImageUrl };
              updateProgress(item);
            }
            // if (item.module === "manim") {
            //   const manimResponseTask = await fetch('https://plato-vm.westus.cloudapp.azure.com:7169/Transcript/GenerateVideo?videoQuery='+item.url+"&caption="+item.text); // Simulate API call for video
            //   const manimResponse = await manimResponseTask.json();
            //   var caption = manimResponse["newCaption"]??"";
            //   var videoUrl = manimResponse["url"]??"";
            //   updatedItem = { ...item, url: videoUrl, text: caption }; // Replace `url` with video url
            // }
            if (item.module === "recommendation") {
              const recommendationsResponseTask = await fetch('https://plato-vm.westus.cloudapp.azure.com:5001/Transcript/GetOptionsBackground?options='+item.options, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                }}); // Simulate API call for video
              const recommendationsResponse = await recommendationsResponseTask.text();
              updatedItem = { ...item, url: recommendationsResponse }; // Replace `url` with video url
              updateProgress(item);
            }
            return updatedItem; // Keep non-image modules unchanged
          })
        );

        //manim parallel
        // var updatedData = await Promise.all(
        //   updatedDataWithoutManim.flatMap(async (item) => {
        //     let updatedItem = { ...item };
        //     // If module is "image", call the API
        //     if (item.module === "manim") {
        //       const manimResponseTask = await fetch('https://plato-vm.westus.cloudapp.azure.com:5001/Transcript/GenerateVideo?videoQuery='+item.url+"&caption="+item.text, {
        //         method: "GET",
        //         headers: {
        //             "Authorization": `Bearer ${token}`
        //         }}); // Simulate API call for video
        //       const manimResponse = await manimResponseTask.json();
        //       var caption = manimResponse["newCaption"]??"";
        //       var videoUrl = manimResponse["url"]??"";
        //       if (videoUrl.toLowerCase().includes("error")) {
        //         return null; 
        //       }
        //       updatedItem = { ...item, url: videoUrl, text: caption }; // Replace `url` with video url
        //       updateProgress(item);
        //     }
        //     return updatedItem; // Keep non-image modules unchanged
        //   })
        // );
        // updatedData = updatedData.filter(item => item !== null);
        // var updatedDataStringified = JSON.stringify(updatedData);
        // console.log(updatedData); 
        
        // const response = await fetch('https://plato-vm.westus.cloudapp.azure.com:5001/Transcript/RefineTranscript?query='+query+"&transcript="+updatedDataStringified); // Replace with your API URL
        // // Check if the response is OK (status 200–299)
        // if (!response.ok) {
        //   throw new Error(`HTTP error! Status: ${response.status}`);
        // }
        // // Parse response as text, then convert it to JSON
        // let textResponse = await response.text();
        // textResponse   = textResponse.replace(/^```json\s|\s```$/g, '');
        // const jsonResponse = JSON.parse(textResponse);
        // console.log(jsonResponse);
        // jsonResponse = jsonResponse.filter(item => item !== null);
        // console.log("#1 refined data");
        // setScreenplay(jsonResponse); // Update state with processed data
        setScreenplay(updatedDataWithoutManim);
        return updatedDataWithoutManim;
      } catch (err) {
        console.error("Error processing images:", err);
        return null;
      }
    };

    const processVideo = async (updatedDataWithoutManim, token) => {
        var updatedData = await Promise.all(
          updatedDataWithoutManim.flatMap(async (item) => {
            let updatedItem = { ...item };
            // If module is "image", call the API
            if (item.module === "manim") {
              const manimResponseTask = await fetch('https://plato-vm.westus.cloudapp.azure.com:5001/Transcript/GenerateVideo?videoQuery='+item.url+"&caption="+item.text, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                }}); // Simulate API call for video
              const manimResponse = await manimResponseTask.json();
              var caption = manimResponse["newCaption"]??"";
              var videoUrl = manimResponse["url"]??"";
              if (videoUrl.toLowerCase().includes("error")) {
                return null; 
              }
              updatedItem = { ...item, url: videoUrl, text: caption }; // Replace `url` with video url
              //updateProgress(item);
            }
            return updatedItem; // Keep non-image modules unchanged
          })
        );
        updatedData = updatedData.filter(item => item !== null);
        var updatedDataStringified = JSON.stringify(updatedData);
        console.log(updatedData); 
        setScreenplay(updatedData);
        return updatedData;
    }

    const uploadTranscript = async (title, transcript, backgoundGenerated, token) => {
      const data = {
          userId: userId || email,
          title: title,
          backgroundUrl: backgoundGenerated,
          transcript: transcript
      };
  
      try {
          const response = await fetch('https://plato-vm.westus.cloudapp.azure.com:5001/Transcript/upload', {
              method: 'POST',
              headers: {
                  "Content-Type": "application/json",
                  "Authorization": `Bearer ${token}`
              },
              body: JSON.stringify(data)
          });
  
          if (!response.ok) {
              throw new Error(`HTTP error! Status: ${response.status}`);
          }
  
          const result = await response.json();
          console.log("Upload successful:", result);
          setRetriggerHistory((retriggerHistory) => !retriggerHistory);
      } catch (error) {
          console.error("Error uploading transcript:", error);
      }
    };
    // Function to make the API call
    const fetchData = async (query) => {
      if (creditsLeft !== null && creditsLeft <= 0) return;
      try {
        setLoading(true);
        const token = localStorage.getItem("google_token");
        const backgoundGenerated = fetchBackground(query, token);
        // Make the API call
        const response = await fetch(`https://plato-vm.westus.cloudapp.azure.com:5001/Transcript/GetTranscript?query=${encodeURIComponent(query)}&userId=${encodeURIComponent(userId || "")}`,
          {
          method: "GET",
          headers: {
              "Authorization": `Bearer ${token}`
          }}); // Replace with your API URL
        // Check if the response is OK (status 200–299)
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        // Parse response as text, then convert it to JSON
        let textResponse = await response.text();
        textResponse   = textResponse.replace(/^```json\s|\s```$/g, '');
        const jsonResponse = JSON.parse(textResponse);
        var keys = jsonResponse.keys();
        // Update state with parsed JSON data
        // setScreenplay(jsonResponse);
        setScreenplayLength(jsonResponse.length);
        const processedJson = await processImages(jsonResponse, token);
        setCurrentLine(0);
        resumedRef.current = 0;
        setLoading(false); // Hide loading indicator
        // Deduct one credit now that the lesson is fully loaded
        try {
          await fetch(`https://plato-vm.westus.cloudapp.azure.com:5001/Transcript/DeductCredit?userId=${userId || email}`, {
            method: 'POST',
            headers: { "Authorization": `Bearer ${token}` }
          });
          if (onCreditUsed) onCreditUsed();
        } catch (e) { console.error('Credit deduction failed', e); }
        //const convertVideo = await processVideo(jsonResponse);
        const processedJsonAfterManim = await processVideo(processedJson, token);
        uploadTranscript(query, processedJson, backgoundGenerated, token);
      } catch (err) {
        // Handle errors
        setError(err.message);
        setLoading(false); // Hide loading indicator
      }
    };
    // Function to make the API call
    const fetchBackground = async (query, token) => {
      try {
        // Make the API call
        const response = await fetch('https://plato-vm.westus.cloudapp.azure.com:5001/Transcript/GenerateImage?prompt='+query, {
          method: "GET",
          headers: {
              "Authorization": `Bearer ${token}`
          }}); // Replace with your API URL
        // Check if the response is OK (status 200–299)
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        // Parse response as text, then convert it to JSON
        let textResponse = await response.text();
        console.log(textResponse);
        setBackgroundUrl(textResponse);
        setBackgroundUrlActive(textResponse);
        return textResponse;
      } catch (err) {
        // Handle errors
        setError(err.message);
        return "";
      }
    };
    if(query){
      setDisplayQuery(query);
      setDoubts([]);
      setLessonCompleted(false);
      fetchData(query);
    }      
  }, [query]); // Empty dependency array to run only once on component mount
  
  useEffect(() => {

    const processImages = async (initialJson, token) => {
      try {
        // Clone the data to modify
        const updatedData = await Promise.all(
          initialJson.map(async (item) => {
            // If module is "image", call the API
            if (item.module === "image") {
              const subArrayString = JSON.stringify(screenplay.slice(0, currentLine + 1));
              const imageUrls = await fetch(`https://plato-vm.westus.cloudapp.azure.com:5001/Transcript/GetImage?imageQuery=${encodeURIComponent(item.url)}&topic=${encodeURIComponent(query)}&currentCaption=${encodeURIComponent(item.text)}`, {
                method: "POST",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ transcriptCovered: subArrayString, urlsCovered: "[]" })
              }); // Simulate API call for images
              var imageUrlsText = await imageUrls.text();
              var imageUrlsParsed = JSON.parse(imageUrlsText);
              // debugger;
              // var imageUrlsString =  imageUrlsParsed.join(",");
              // const imgCaption = await fetch('https://plato-vm.westus.cloudapp.azure.com:7169/Transcript/GenerateImageDescription?imgUrlsString='+imageUrlsString+"&prompt="+item.text+"&topic="+query); 
              // var imgCaptionJson = await imgCaption.json();
              return { ...item, url: imageUrlsParsed["url"], text: imageUrlsParsed["newCaption"] }; // Replace `url` with array of URLs
            }
            if (item.module === "video") {
              const videoResponseTask = await fetch(`https://plato-vm.westus.cloudapp.azure.com:5001/Transcript/GetShortVideos?videoQuery=${encodeURIComponent(item.url)}&lessonText=${encodeURIComponent(item.text)}&currentCaption=${encodeURIComponent(item.text)}`, {
                method: "POST",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ urlsCovered: "[]" })
              }); // Simulate API call for video
              const videoResponse = await videoResponseTask.json();
              var caption = videoResponse["newCaption"];
              const videoId = videoResponse["videoId"];
              const sourceEmbedUrl = 'https://www.youtube.com/embed/' + videoId;
              return { ...item, url: sourceEmbedUrl, text: caption }; // Replace `url` with video url
            }
            return item; // Keep non-image modules unchanged
          })
        );
        console.log(updatedData);
        setDoubtscreenplay(updatedData); // Update state with processed data
      } catch (err) {
        console.error("Error processing images:", err);
      }
    };
    // Function to make the API call
    const fetchData = async (query) => {
      try {
        setLoading(true);
        const token = localStorage.getItem("google_token");
        setDoubtMode(true);
        // Make the API call
        const subArrayString = JSON.stringify(screenplay.slice(0, currentLine + 1));
        const subArrayStringLeft = JSON.stringify(screenplay.slice(currentLine + 1, screenplayLength));
        const response = await fetch('https://plato-vm.westus.cloudapp.azure.com:5001/Transcript/GetDoubtAnswerTranscript?query='+encodeURIComponent(query), {
          method: "POST",
          headers: {
              "Authorization": `Bearer ${token}`,
              "Content-Type": "application/json"
          },
          body: JSON.stringify({ transcriptCovered: subArrayString, transcriptLeft: subArrayStringLeft })
        }); // Replace with your API URL
        // Check if the response is OK (status 200–299)
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        // Parse response as text, then convert it to JSON
        let textResponse = await response.text();
        textResponse   = textResponse.replace(/^```json\s|\s```$/g, '');
        const jsonResponse = JSON.parse(textResponse);
        const screenplayResponse = Array.isArray(jsonResponse) ? jsonResponse : jsonResponse["doubtAnswer"];
        const convertImage = await processImages(screenplayResponse, token);
        //const convertVideo = await processVideo(jsonResponse);
      } catch (err) {
        // Handle errors
        setError(err.message);
      } finally {
        setLoading(false); // Hide loading indicator
      }
    };
    if(doubtQuery)
      fetchData(doubtQuery);
  }, [doubtQuery]); // Empty dependency array to run only once on component mount

  const handleInteractiveQuestionAnswered = (isCorrect) => {
    setInteractiveQuestionAnswered(true);
    const nextIndex = currentLine + 1;
    if (screenplay && screenplay[nextIndex] && screenplay[nextIndex].module === "avatar") {
      const prefix = "Great, now that you understood this, ";
      setScreenplay(screenplay.map((item, idx) =>
        idx === nextIndex ? { ...item, text: prefix + item.text } : item
      ));
    }
  };

  const triggerAvatarCorrect = (explanation) => {
    setCorrectAnswer(explanation || true);
  }

  const triggerAvatarIncorrect = () => {
    setIncorrectAnswer(true);
  }

  const [revealAnswer, setRevealAnswer] = useState({ answer: "", explanation: "" });

  const triggerAvatarRevealAnswer = (answer, explanation) => {
    setRevealAnswer({ answer, explanation });
  }

  useEffect(() => {
    const speakAvatarCorrect = async () => {
    if(screenplay && correctAnswer){
      const text = typeof correctAnswer === "string" && correctAnswer.length > 0
        ? correctAnswer
        : "Great job! You got it right!";
      await talkingHead.speakText(text);
      setCorrectAnswer(false);
    }
    }
    speakAvatarCorrect();
  }, [correctAnswer]);

  useEffect(() => {
    const speakAvatarCorrect = async () => {
    if(screenplay && incorrectAnswer){
      await talkingHead.speakText( "Oops, that's not right, but you can do this, try again!" );
      setIncorrectAnswer(false);
    }
    }
    speakAvatarCorrect();
  }, [incorrectAnswer]);

  useEffect(() => {
    const speakRevealAnswer = async () => {
      if (screenplay && revealAnswer.answer) {
        const text = revealAnswer.explanation && revealAnswer.explanation.length > 0
          ? revealAnswer.explanation
          : `That's okay, the right answer is ${revealAnswer.answer}`;
        await talkingHead.speakText(text);
        setRevealAnswer({ answer: "", explanation: "" });
      }
    };
    speakRevealAnswer();
  }, [revealAnswer]);

  const handleSpeakSentence = (sentence) => {
    setHighlightedSentence(sentence);
    //setCurrentLine(currentLine++);
  };

  const handleSearch = (queryText) => {
    setQuery(queryText);
  };

  const handleDoubt = (queryText) => {
    setDoubtQuery(queryText);
    setDoubts(prev => [...prev, queryText]);
  };

  const updateCurrentLine = (reset=false, previous=false) => {
    let newLine = currentLine + 1;
    if(reset){
      setCurrentLine(0);
      return;
    }
    if(previous)
      newLine = currentLine - 1;
    setCurrentLine(newLine);
  }

  const triggerPlayAgain = () => {
    if(!doubtMode){
      resumedRef.current = 0;
      setRetriggerScreenplay((retriggerScreenplay) => !retriggerScreenplay);
      setCurrentLine(0);
      setBackgroundUrlActive(backgroundUrl);
      setImageOrVideoOrQuizOnScreen(false);
    }
  };

  const triggerPause = () => {
    if(!doubtMode){
      resumedRef.current = 1;
      setResumed(false);
    }
    else{
      resumedRefDoubt.current = 1;
      setResumedDoubt(false);
    }
  };

  const triggerContinue = () => {
    if (talkingHead) talkingHead.stopSpeaking();
    setPlayVideo(false);
    if(!doubtMode){
      setCurrentLine((currentLine) => currentLine + 1);
      resumedRef.current = 2;
      setImageOrVideoOrQuizOnScreen(false);
      setRetriggerScreenplay((retriggerScreenplay) => !retriggerScreenplay);
    }
    else{
      setCurrentDoubtLine((currentDoubtLine) => currentDoubtLine + 1);
      resumedRefDoubt.current = 2;
      setRetriggerDoubtScreenplay((retriggerDoubtScreenplay) => !retriggerDoubtScreenplay);
    }
  };

  const jumpToSlide = (index) => {
    if (!screenplay || !talkingHead || doubtMode) return;
    // Clear the avatar's internal speech queue immediately so the new slide's
    // text starts speaking right away instead of queuing behind the current slide.
    talkingHead.stopSpeaking();
    setPlayVideo(false);
    setCurrentLine(index);
    resumedRef.current = 2;
    setImageOrVideoOrQuizOnScreen(false);
    setRetriggerScreenplay((retriggerScreenplay) => !retriggerScreenplay);
  };

  const triggerHandRaised = () => {
    setShowConfirmationOptions(false);
    triggerPause();
    setHandRaised(true);
  };

  const triggerHandBroughtDown = () => {
    setHandRaised(false);
  };

  const resumeAfterDoubtCleared = () => {
    setShowConfirmationOptions(false);
    triggerResume();
    setRaiseHandStatus(false);
    //setCurrentLine(currentLine++);
  };

  const DoubtNotCleared = () => {
    //talkingHead.pauseSpeaking();
    triggerHandRaised();
    setRaiseHandStatus(true);
    setShowConfirmationOptions(false);
    //setCurrentLine(currentLine++);
  };

  const forceBringDownHand = () => {
    //talkingHead.pauseSpeaking();
    setRaiseHandStatus(false);
    //setCurrentLine(currentLine++);
  };

  const triggerResume = () => {
    //talkingHead.startSpeaking();
    if(!doubtMode){
      resumedRef.current = 2;
      setResumed(true);
    }
    else{
      resumedRefDoubt.current = 2;
      setResumedDoubt(true);
    }
    //setCurrentLine(currentLine++);
  };

  const styles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "rgba(5, 15, 30, 0.75)",
      backdropFilter: "blur(6px)",
      WebkitBackdropFilter: "blur(6px)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 2000,
      pointerEvents: "all",
    },
    text: {
      marginTop: "16px",
      color: "rgba(255,255,255,0.85)",
      fontSize: "13px",
      fontWeight: "600",
      letterSpacing: "2px",
      textTransform: "uppercase",
    },
    loaderContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: "40px 56px",
      borderRadius: "20px",
      background: "rgba(255,255,255,0.05)",
      border: "1px solid rgba(255,255,255,0.1)",
      boxShadow: "0 24px 48px rgba(0,0,0,0.4)",
    }
  };

  const renderModule = (line) => {
    if(line){
      switch (line.module) {
        case "reset":
          return <Whiteboard highlightedSentence={"Search a topic"}/>
        case "start":
          return <Whiteboard highlightedSentence={"Alright! let's get started!"} />;
        case "end":
          return <Whiteboard highlightedSentence={"Thank you for watching"} />;
        case "avatar":
          return <Whiteboard content={line.url} />;
        case "image":
          //return <Whiteboard imageUrls={line.url} />;
          return (
            <div>
            {/* <img src={line.url[0]} alt="Visual" style={{ width: "250px", height: "250px" }} />
            <br/>
            <img src={line.url[1]} alt="Visual" style={{ width: "250px", height: "250px" }} /> */}
            <ImageViewer imageUrl={line.url} finishedTalking={finishedTalking} setFinishedTalking={setFinishedTalking} onClose={triggerContinue}/>
            </div>
            );
        case "genimage":
          return (
            <div>
              <ImageViewer imageUrl={line.url} finishedTalking={finishedTalking} setFinishedTalking={setFinishedTalking} onClose={triggerContinue}/>
            </div>
          );
        case "video":
          return (
            // <iframe
            //   width="500px"
            //   height="300px"
            //   src={line.url}
            //   title="Video"
            //   frameBorder="0"
            //   allowFullScreen
            // ></iframe>
            <VideoPlayer url={line.url} playVideoTrigger={playVideo} onClose={triggerContinue}/>
          );
        case "manim":
          if (!line.url || !line.url.toLowerCase().includes('.mp4')) {
            return (
              <div style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "14px",
                padding: "32px 40px",
                borderRadius: "16px",
                background: "rgba(255,255,255,0.07)",
                backdropFilter: "blur(10px)",
                border: "1px solid rgba(255,255,255,0.12)",
                color: "rgba(255,255,255,0.75)",
                fontSize: "13px",
                letterSpacing: "1.5px",
                textTransform: "uppercase",
              }}>
                <div className="plato-ring" />
                Animation still generating…
              </div>
            );
          }
          return (
            // <iframe
            //   width="500px"
            //   height="300px"
            //   src={line.url}
            //   title="Video"
            //   frameBorder="0"
            //   allowFullScreen
            // ></iframe>
            <Mp4Player url={line.url} onClose={triggerContinue}/>
          );
        case "image":
          //return <Whiteboard imageUrls={line.url} />;
          return ( 
            <div>
            {/* <img src={line.url[0]} alt="Visual" style={{ width: "250px", height: "250px" }} />
            <br/>
            <img src={line.url[1]} alt="Visual" style={{ width: "250px", height: "250px" }} /> */}
            <ImageViewer imageUrl={line.url} finishedTalking={true}/>
            </div>
            );
        case "quiz":
          var options = line.options.split(";");
          return (
            // <iframe
            //   width="500px"
            //   height="300px"
            //   src={line.url}
            //   title="Video"
            //   frameBorder="0"
            //   allowFullScreen
            // ></iframe>
            <QuizApp questionProp={line.question} answerProp={line.answer} optionsProp={options} triggerAvatarCorrect={triggerAvatarCorrect} triggerAvatarIncorrect={triggerAvatarIncorrect}/>
          );
        case "interactivequestion":
          return (
            <InteractiveQuestion
              questionProp={line.question || line.text}
              answerProp={line.url}
              topicProp={testModeTopic || query}
              triggerAvatarCorrect={triggerAvatarCorrect}
              triggerAvatarRevealAnswer={triggerAvatarRevealAnswer}
              onAnswered={handleInteractiveQuestionAnswered}
            />
          );
        case "recommendation":
          var options = line.options.split(";");
          var backgroundUrls = line.url.split(";");
          return (
            // <iframe
            //   width="500px"
            //   height="300px"
            //   src={line.url}
            //   title="Video"
            //   frameBorder="0"
            //   allowFullScreen
            // ></iframe>
            <Recommendations optionsProp={options} triggerNewTopicProp={triggerNewTopic} backgroundUrlsProp={backgroundUrls} onContinue={triggerContinue}/>
            );
        default:
          return null;
      }
    }
  };

  const navBtnStyle = {
    height: "36px",
    width: "36px",
    borderRadius: "50%",
    border: "none",
    background: "rgba(255,255,255,0.15)",
    backdropFilter: "blur(4px)",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "white",
    transition: "background 0.2s",
  };

  const controlBtnStyle = {
    height: "40px",
    width: "40px",
    borderRadius: "50%",
    border: "none",
    background: "rgba(255,255,255,0.18)",
    backdropFilter: "blur(6px)",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "white",
    transition: "background 0.2s",
    flexShrink: 0,
  };

  return (
    <div style={{width:"100%"}} className="relative w-full h-screen">

      {/* ── Navbar ── */}
      {creditsLeft === 0 && (
        <OutOfCreditsModal userId={userId} email={profile?.email} />
      )}

      <div style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "64px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 16px",
        background: "rgba(10, 30, 50, 0.55)",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        borderBottom: "1px solid rgba(255,255,255,0.08)",
        zIndex: 1000,
        boxSizing: "border-box",
      }}>
        {/* Left — spacer so title stays centered when sidebar closed */}
        <div style={{width: "50px", flexShrink: 0}} />

        {/* Center — brand */}
        <h1 style={{
          margin: 0,
          color: "aliceblue",
          fontSize: "22px",
          letterSpacing: "4px",
          fontWeight: 700,
          userSelect: "none",
        }}>PLATO</h1>

        {/* Right — credits + user avatar + logout */}
        <div style={{display:"flex", alignItems:"center", gap:"10px", flexShrink: 0}}>
          {creditsLeft !== null && (
            <div title="Lessons remaining" style={{
              display: "flex", alignItems: "center", gap: "5px",
              padding: "4px 10px", borderRadius: "20px",
              background: creditsLeft <= 1 ? "rgba(239,68,68,0.25)" : "rgba(255,255,255,0.1)",
              border: creditsLeft <= 1 ? "1px solid rgba(239,68,68,0.5)" : "1px solid rgba(255,255,255,0.15)",
              fontSize: "13px", fontWeight: 600, color: creditsLeft <= 1 ? "rgba(255,120,120,0.95)" : "rgba(255,255,255,0.85)",
            }}>
              <span>🪙</span>
              <span>{creditsLeft}</span>
            </div>
          )}
          {profile && (
            <>
              <img
                src={profile.picture}
                alt="user image"
                title={profile.name}
                style={{height:"36px", width:"36px", borderRadius:"50%", border:"2px solid rgba(255,255,255,0.3)"}}
              />
              <button style={navBtnStyle} onClick={logOut} title="Sign out">
                <LogOut size={16} />
              </button>
            </>
          )}
        </div>
      </div>

      <div className="container" style={{paddingTop: testMode ? "128px" : "80px"}}>
        {!testMode && <HistorySidebar setNewQuery={setHistoryQuery} retriggerHistoryProp={retriggerHistory} userIdProp={userId || email}/>}
        {rocket && <Rocket />}

        {/* ── Search + Controls ── */}
        <div style={{textAlign:"center", paddingBottom:"20px"}}>
          {!testMode && <SearchBar placeholder="Search here..." onSearch={handleSearch} />}

          {!testMode && displayQuery && (
            <div style={{
              display: "inline-block",
              marginTop: "6px",
              padding: "3px 14px",
              borderRadius: "999px",
              background: "rgba(255,255,255,0.12)",
              color: "rgba(255,255,255,0.85)",
              fontSize: "13px",
              letterSpacing: "0.5px",
            }}>
              {displayQuery}
            </div>
          )}

          {/* Controls pill */}
          <div style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            marginTop: "12px",
            padding: "8px 18px",
            borderRadius: "999px",
            background: "rgba(0,0,0,0.35)",
            backdropFilter: "blur(10px)",
            WebkitBackdropFilter: "blur(10px)",
            border: "1px solid rgba(255,255,255,0.12)",
          }}>
            <button style={controlBtnStyle} onClick={triggerPause} title="Pause">
              <Pause size={18} />
            </button>
            <button style={controlBtnStyle} onClick={triggerResume} title="Play">
              <Play size={18} />
            </button>
            <button style={controlBtnStyle} onClick={triggerPlayAgain} title="Restart">
              <RotateCcw size={18} />
            </button>
            {/* Continue button — only for quiz and interactivequestion */}
            {imageOrVideoOrQuizOnScreen &&
             (screenplay?.[currentLine]?.module === "quiz" || screenplay?.[currentLine]?.module === "interactivequestion") &&
             (screenplay?.[currentLine]?.module !== "interactivequestion" || interactiveQuestionAnswered) && (
              <button style={{...controlBtnStyle, background:"rgba(99,179,237,0.35)"}} className="btn-pulse" onClick={triggerContinue} title="Continue">
                <ArrowRight size={18} />
              </button>
            )}
            {screenplay && currentLine !== -1 && (
              <RaiseHandButton handRaised={triggerHandRaised} handBroughtDown={triggerHandBroughtDown} raiseHandState={raiseHandStatus}/>
            )}
            {showConfirmationOptions && (
              <>
                <button style={{...controlBtnStyle, background:"rgba(72,199,142,0.4)"}} onClick={resumeAfterDoubtCleared} title="Yes, doubt cleared">
                  <Check size={18} />
                </button>
                <button style={{...controlBtnStyle, background:"rgba(239,68,68,0.4)"}} onClick={DoubtNotCleared} title="No, still have doubt">
                  <X size={18} />
                </button>
              </>
            )}
          </div>

          {!doubtScreenplay && handRaised && (
            <div style={{marginTop:"12px"}}>
              <DoubtBar placeholder="Enter your doubt here..." onSearch={handleDoubt} />
            </div>
          )}
        </div>

        <div>
          {loading && (
            <div style={styles.overlay}>
              <div style={styles.loaderContainer}>
                <style>{`
                  @keyframes plato-spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                  }
                  .plato-ring {
                    width: 52px; height: 52px;
                    border-radius: 50%;
                    border: 3px solid rgba(255,255,255,0.08);
                    border-top-color: rgba(99,179,237,0.9);
                    animation: plato-spin 0.9s linear infinite;
                  }
                `}</style>
                <div className="plato-ring" />
                <div style={styles.text}>Generating lesson…</div>
              </div>
            </div>
          )}
          {avatarLoading && (
            <div className="loading-container">
              <div className="spinner"></div>
              <p className="progress-text">AVATAR {avatarLoadingProgress}% LOADED</p>
            </div>
          )}
          <div className="containerRow">
            <div id="avatar"></div>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              {screenplay && !handRaised && currentLine !== -1 && renderModule(screenplay[currentLine])}
              {doubtScreenplay && handRaised && currentDoubtLine !== -1 && renderModule(doubtScreenplay[currentDoubtLine])}

              {/* Slide navigation dots — below canvas only */}
              {screenplay && !doubtMode && (
                <div style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexWrap: "wrap",
                  gap: "6px",
                  marginTop: "10px",
                  width: "520px",
                }}>
                  {screenplay.map((_, idx) => (
                    <button
                      key={idx}
                      onClick={() => jumpToSlide(idx)}
                      title={`Slide ${idx + 1}: ${screenplay[idx]?.module}`}
                      style={{
                        width: "10px",
                        height: "10px",
                        borderRadius: "2px",
                        border: "none",
                        cursor: "pointer",
                        padding: 0,
                        background: idx === currentLine
                          ? "rgba(99,179,237,0.95)"
                          : "rgba(255,255,255,0.25)",
                        boxShadow: idx === currentLine
                          ? "0 0 6px rgba(99,179,237,0.7)"
                          : "none",
                        transform: idx === currentLine ? "scale(1.3)" : "scale(1)",
                        transition: "all 0.2s ease",
                        flexShrink: 0,
                      }}
                    />
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
//AIzaSyDUkExQfbMXDMvouW4trv0jT-kCj5nqadY